import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import { createBillingSession, createDashboardSession, createStripeUser } from '../../../redux/actions/stripeActions';
import { getExperientialRewardDetails } from '../../../redux/actions/userActions';
import urls from '../../../routing/urls';
import ExperientialRewardDetails from '../ExperientialRewardDetails/ExperientialRewardDetails';

import styles from './PaymentsSettings.module.scss';

const PaymentsSettings = () => {
  const { t } = useTranslation('common');
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const isExperientialPaymentInfoAdded = useSelector((state) => state.userReducer.user?.experiential_payment_info);

  useEffect(() => {
    dispatch(getExperientialRewardDetails());
  }, []);

  return (
    <div className={`mx-sm-1 mx-md-3 mx-lg-5 ${styles.paymentsSettings}`}>
      <div className={styles.mainHeading}>{t('paymentSettings.paymentAndSubscription')}</div>
      <div>
        <div className={styles.paymentHeading}>{t('paymentSettings.account')}</div>
        <div className={styles.paymentSubheading}>{t('paymentSettings.billingPaymentMethods')}</div>
        <div className={styles.paymentContent}>
          {t('paymentSettings.primaryBillingDescription')}
          <br />
          {t('paymentSettings.subscriptionUpgrades')}
        </div>
      </div>
      <div className={styles.addPaymentMethod}>
        <div className={styles.paymentContent}>{t('paymentSettings.addUpdateRemove')}</div>
        <button onClick={() => dispatch(createBillingSession())} type="button" className={styles.addPayment}>
          {t('paymentSettings.manageBillingMethods')}
        </button>
      </div>
      <div>
        <div className={styles.paymentHeading}>{t('paymentSettings.rewards')}</div>
        <div className={styles.paymentSubheading}>{t('paymentSettings.rewardPaymentMethod')}</div>
        <div className={styles.paymentContent}>
          {t('paymentSettings.rewardMethodDescription')}
          <br />
          {t('paymentSettings.allRewardPayments')}
          <br />
          <b>{t('paymentSettings.necessaryInfo')}</b>
        </div>

        <div className={styles.paymentContent}>{t('paymentSettings.replaceRemovePayout')}</div>
        <button onClick={() => dispatch(createStripeUser())} type="button" className={styles.addPayment}>
          {t('paymentSettings.manageRewardPayout')}
        </button>
        <div className={styles.paymentsDashboard}>{t('paymentSettings.stripeDashboard')}</div>
        <div className={styles.paymentContent}>
          {t('paymentSettings.stripeDashboardDescription')}
          <br />
          {t('paymentSettings.viewBalanceTrack')}
        </div>
        <button onClick={() => dispatch(createDashboardSession())} type="button" className={styles.addPayment}>
          {t('paymentSettings.visitStripeDashboard')}
        </button>
        <div>
          <div className={`${styles.paymentSubheading} mt-4`}>{t('paymentSettings.experientialRewardDetails')}</div>
          <div>
            <div className={styles.paymentContent}>{t('paymentSettings.experientialRewardDescription')}</div>
            {isExperientialPaymentInfoAdded ? (
              <ExperientialRewardDetails />
            ) : (
              <button
                onClick={() => navigate(urls.experientialRewardsDetails)}
                type="button"
                className={styles.addPayment}
              >
                {t('paymentSettings.addExperientialDetails')}
              </button>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default PaymentsSettings;
